export default "__VITE_ASSET__DIeJJH6z__"